import { render, staticRenderFns } from "./fodderView.vue?vue&type=template&id=4b6720b6&scoped=true&"
import script from "./fodderView.vue?vue&type=script&lang=js&"
export * from "./fodderView.vue?vue&type=script&lang=js&"
import style0 from "./fodderView.vue?vue&type=style&index=0&id=4b6720b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6720b6",
  null
  
)

export default component.exports